import {SCHEDULE_SESSION_DISPLAY_TYPE_SPEEDDATE} from '../constants';

export function isSessionSpeeddate(session) {
    return session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_SPEEDDATE;
}
